import { bridgeAtom, useValue } from '@/store';

const testPattern = (pattern: string, value: string): boolean => {
  try {
    return new RegExp(pattern).test(value);
  } catch {
    return false;
  }
};

export const useIsWidgetDisabled = () => {
  const { widgetExclusions, widgetWhitelist } = useValue(bridgeAtom);
  const { pathname } = window.location;

  const isExcluded = widgetExclusions?.some((exclusion) => testPattern(exclusion, pathname));
  const isNotWhitelisted = widgetWhitelist?.length
    ? !widgetWhitelist.some((pattern) => testPattern(pattern, pathname))
    : false;

  return Boolean(isExcluded || isNotWhitelisted);
};
